<template>
  <el-container>
    <el-header
      >Envio de mensaje de estado de Reporte por medio de SMS</el-header
    >
    <el-main>
      <el-form :model="form" :rules="rules" ref="ruleForm" status-icon>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
            <el-form-item label="Destino:" prop="destination">
              <el-input type="number" v-model="form.destination"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
            <el-form-item label="Mensaje: " prop="message">
              <el-input type="textarea" v-model="form.message"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-button type="primary" @click="onSubmit('ruleForm')"
              >Enviar Mensaje de Texto</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </el-main>
  </el-container>
</template>
<script>
  import { sendSMS } from '@/api/reporte'
  export default {
    data() {
      return {
        form: {
          destination: '',
          message: ''
        },
        rules: {
          destination: [
            {
              required: true,
              message: 'El número de destino es requerido',
              trigger: 'blur'
            },
            {
              min: 10,
              max: 10,
              message: 'El número de destino debe tener 10 dígitos',
              trigger: 'blur'
            }
          ]
        }
      }
    },
    methods: {
      onSubmit(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            sendSMS(this.form)
              .then(response => {
                console.log(response)
                this.$message({
                  message: 'Mensaje enviado correctamente',
                  type: 'success'
                })
              })
              .catch(err => {
                console.log('error: ', err)
              })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields()
      }
    }
  }
</script>
